/**
 * Priority Badge Component
 * Displays priority with color-coded badge
 */

import React from 'react';
import { Chip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { getPriorityColor } from '../../utils/themeHelpers';

interface PriorityBadgeProps {
  priority: 'high' | 'medium' | 'low';
}

const getPriorityLabel = (priority: 'high' | 'medium' | 'low'): string => {
  const labels: Record<'high' | 'medium' | 'low', string> = {
    high: 'High',
    medium: 'Medium',
    low: 'Low',
  };
  return labels[priority] || 'Unknown';
};

export const PriorityBadge: React.FC<PriorityBadgeProps> = ({ priority }) => {
  const theme = useTheme();
  const label = getPriorityLabel(priority);
  const colors = getPriorityColor(priority, theme);

  return (
    <Chip
      label={label}
      size="small"
      sx={{
        backgroundColor: colors.backgroundColor,
        color: colors.color,
        fontWeight: theme.typography.button.fontWeight,
        fontSize: theme.typography.caption.fontSize,
        height: 24,
        minWidth: 60,
        '& .MuiChip-label': {
          padding: theme.spacing(0, 1),
        },
      }}
    />
  );
};

